import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import * as RB from "react-bootstrap";
import { useLoader } from "../../Loader";
import DataTable from "react-data-table-component";

import {
  Delete,
  Visibility,
  Download,
  History,
  ReceiptLong,
  Send,
  SendTwoTone,
  MoreHoriz,
  LocalShipping,
  Create,
} from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import { Link } from "react-router-dom";
import { showMessage } from "../../Utils/comman";
import Multiselect from "multiselect-react-dropdown";
import DatePicker from "react-datepicker";
import { filter } from "lodash";
import { DocumentDownload } from "iconsax-react";

function List(props) {
  const [quotationList, setQuotationList] = useState([]);
  const { startLoader, stopLoader } = useLoader();
  const [vehicleFormData, setVehicleFormData] = useState({
    driverName: "",
    driverNo: "",
    transporterName: "",
    destination: "",
    billofLanding: "",
    motorVehicleNo: "",
  });

  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");

  const [filters, setFilters] = useState({
    city: "",
    district: "",
    state: "",
    product: "",
    sku: "",
    salesBy: "",
    zone: "",
    cp: "",
    dateRange: "",
    fromDate: "",
    toDate: "",
  });
  const [productOptions, setProductOptions] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const [cpOptions, setCpOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [filterDateRange, setFilterDateRange] = useState([null, null]);
  const [filterStartDate, filterEndDate] = filterDateRange;

  const roleTitles = {
    rsm: "Regional Sales Manager",
    cfo: "Chief Financial Officer",
    ceo: "Chief Executive Officer",
    channel_partner: "Channel Partner",
  };

  const [cityOptions, setCityOptions] = useState([]);

  const [districtOptions, setDistrictOptions] = useState([]);

  const [stateOptions, setStateOptions] = useState([]);

  const [zonalOptions, setZonalOptions] = useState([
    { id: "Zone", name: "North Zone" },
    { id: "South", name: "South Zone" },
    { id: "East", name: "East Zone" },
    { id: "West", name: "West Zone" },
    { id: "Central", name: "Central Zone" },
  ]);

  const [channelPartnerOptions, setChannelPartnerOptions] = useState([
    { id: "601", name: "ABC Distributors" },
    { id: "602", name: "XYZ Pvt Ltd" },
    { id: "603", name: "Global Traders" },
    { id: "604", name: "Tech Solutions" },
  ]);

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const isSalesExecutive = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Sales_Executive_permissions"
  );
  const isSalesCoordinator = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Sales_Coordinator_permissions"
  );
  const isRsm = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Regional_Sales_Manager_permissions"
  );
  const isStoreManager = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Store_Manager_permissions"
  );
  const isCeo = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Chief_Executive_Officer_permissions"
  );
  const isCfo = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Chief_Financial_Officer_permissions"
  );
  const isBrandManager = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Brand_Manager_permissions"
  );
  const isLogisticManager = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Logistic_Department_permissions"
  );

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const columns = [
    {
      name: "Order Id",
      selector: (row) => row.order_id,
    },
    {
      name: "Order Date",
      selector: (row) => moment(row.order_date).format("DD-MM-yyyy"),
    },
    {
      name: "Channel Partner",
      selector: (row) => (
        <>
          {row.channel_partner_name}
          <br />

          {row.channel_partner_no}
        </>
      ),
    },
    {
      name: "No of Product",
      selector: (row) => row?.product?.length,
    },
    {
      name: "Zones",
      selector: (row) => row?.channel_details.zone,
      wrap: true,
      // selector: (row) => row?.order_status +" - " +row?.order_staus_name,
    },
    {
      name: "Order Total",
      selector: (row) => row?.order_total,
      wrap: true,
      // selector: (row) => row?.order_status +" - " +row?.order_staus_name,
    },
    {
      name: "Status",
      selector: (row) => row?.order_status_name,
      wrap: true,
      // selector: (row) => row?.order_status +" - " +row?.order_staus_name,
    },

    {
      name: "View",
      cell: (row) => (
        <>
          <RB.Button
            className="btn-circle"
            variant="outline-primary"
            size="sm"
            onClick={handleView(row)}
          >
            <Visibility />
          </RB.Button>
        </>
      ),
      center: true,
    },
  ];

  useEffect(() => {
    handleFilterSearchClick();
  }, [page, userProfile?.id]);

  useEffect(() => {
    handleFilterSearchClick();
    getAllChannelPartner();
    getProductList();
    fetchStates();
  }, []);

  const getAllChannelPartner = () => {
    utils
      .callAPI("get", `/sales/getAllChannelPartnerList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setCpOptions(res?.result);
        } else {
          setCpOptions([]);
        }
      })
      .catch((err) => {
        setCpOptions([]);
      });
  };

  const getProductList = (val) => {
    utils
      .callAPI("get", `/Product/productCatList?categoryId=${""}`)
      .then((res) => {
        if (typeof res !== "undefined" && res.result) {
          setProductOptions(res.result);
        } else {
          setProductOptions([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching product list:", err);
        setProductOptions([]); // Handle error
      });
  };

  const getOrderList = (filterValues) => {
    console.log("Yeh page valu hai,currentpage", page, countPerPage);
    filterValues = filterValues ?? "";
    console.log("Here iss the filter values", filterValues);
    utils
      .callAPI(
        "get",
        `/sales/getOrdersReport?per_page=${countPerPage}&page=${page}&${filterValues}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setQuotationList(res);
        } else {
          setQuotationList([]);
        }
      })
      .catch((err) => {
        setQuotationList([]);
      });
  };

  useEffect(() => {
    if (filters.state) {
      fetchDistricts(filters.state); // Fetch districts when a state is selected
    } else {
      setDistricts([]);
      setCities([]);
    }
  }, [filters.state]);

  useEffect(() => {
    if (filters.district) {
      fetchCities(filters.district); // Fetch cities when a district is selected
    } else {
      setCities([]);
    }
  }, [filters.district]);

  const fetchStates = () => {
    startLoader();
    utils
      .callAPI("get", `/state/list`)
      .then((res) => {
        setStates(res || []);
        stopLoader();
      })
      .catch(() => {
        setStates([]);
        stopLoader();
      });
  };

  const fetchDistricts = (stateId) => {
    startLoader();
    utils
      .callAPI("get", `/district/list?stateId=${stateId}`) // API to fetch districts
      .then((res) => {
        setDistricts(res || []);
        stopLoader();
      })
      .catch(() => {
        setDistricts([]);
        stopLoader();
      });
  };

  const fetchCities = (districtId) => {
    startLoader();
    utils
      .callAPI("get", `/city/by-district-list?districtId=${districtId}`) // API to fetch cities by district
      .then((res) => {
        console.log("Here is the district and city", districtId, res);
        setCities(res || []);
        stopLoader();
      })
      .catch(() => {
        setCities([]);
        stopLoader();
      });
  };

  const handleDownload = () => {
    // Format date filters
    const formattedFromDate = filterStartDate
      ? moment(filterStartDate).format("YYYY-MM-DD")
      : "";
    const formattedToDate = filterEndDate
      ? moment(filterEndDate).format("YYYY-MM-DD")
      : "";

    // Construct query parameters
    const queryParams = new URLSearchParams({
        order_by:userProfile.employeeId,
      fromDate: formattedFromDate,
      toDate: formattedToDate,
      city: filters.city ?? "",
      district: filters.district ?? "",
      state: filters.state ?? "",
      product: filters.product ?? "",
      sku: filters.sku ?? "",
      zone: filters.zone ?? "",
      channel_partner: filters.cp ?? "",
      byday:
        formattedFromDate && formattedToDate ? "" : filters.dateRange ?? "",
      role: filters.salesBy ?? "",
    });
console.log("Current query params",queryParams.toString())
    const downloadUrl = `${
      process.env.REACT_APP_API_URL
    }/sales/downloadExcelReport?${queryParams.toString()}`;

    window.open(downloadUrl, "_blank");
  };

  const handleView = useCallback((row) => async () => {
   
    const propdata = {
      mode: "view",
      rowData: row,
    };
    console.log(propdata);
    props.onChange(propdata);
  });

  const handleFilterSearchClick = () => {
    filters.fromDate = filterStartDate
      ? moment(filterStartDate).format("YYYY-MM-DD")
      : "";
    filters.toDate = filterEndDate
      ? moment(filterEndDate).format("YYYY-MM-DD")
      : "";

    const selectedState = states.find(
      (state) => state.state_code === filters.state
    );
    const selectedDistrict = districts.find(
      (district) => district.district_code === filters.district
    );
    const selectedCity = cities.find((city) => city.city_code === filters.city);
    const queryParams = new URLSearchParams();
    // queryParams.set("per_page", countPerPage ?? "");
    // queryParams.set("page", page ?? "");
    queryParams.set("fromDate", filters.fromDate ?? "");
    queryParams.set("toDate", filters.toDate ?? "");
    // cities.map((city) => {
    //   city.id === filters.city;
    // });
    queryParams.set("state", selectedState ? selectedState.state_name : "");
    queryParams.set(
      "district",
      selectedDistrict ? selectedDistrict.district_name : ""
    );
    queryParams.set("city", selectedCity ? selectedCity.city_name : "");
    queryParams.set("product", filters.product ?? "");
    queryParams.set("sku", filters.sku ?? "");
    queryParams.set("zone", filters.zone ?? "");
    queryParams.set("channel_partner", filters.cp ?? "");
    if (filters.fromDate && filters.toDate) {
      queryParams.set("byday", "");
    } else {
      queryParams.set("byday", filters.dateRange ?? "");
    }
    queryParams.set("role", filters.salesBy ?? "");
    console.log("Here is the query", queryParams.toString());
    getOrderList(queryParams.toString());
  };

  const handleFilterResetClick = () => {
    setFilters({
      city: "",
      district: "",
      state: "",
      product: "",
      sku: "",
      salesBy: "",
      zone: "",
      cp: "",
      byDay: "",
      fromDate: "",
      toDate: "",
      dateRange: "",
    });

    setFilterDateRange([null, null]);

    const queryParams = new URLSearchParams();
    queryParams.set("per_page", countPerPage ?? "");
    queryParams.set("page", page ?? "");
    queryParams.set("fromDate", "");
    queryParams.set("toDate", "");
    queryParams.set("city", "");
    queryParams.set("district", "");
    queryParams.set("state", "");
    queryParams.set("product", "");
    queryParams.set("sku", "");
    queryParams.set("zone", "");
    queryParams.set("channel_partner", "");
    queryParams.set("byday", "");
    queryParams.set("role", "");

    getOrderList(queryParams.toString());
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleDateChange = (update) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      dateRange: "", // Reset date range selection
    }));
    setFilterDateRange(update);
  };

  const handleDateRangeChange = (e) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      dateRange: e.target.value,
    }));
    setFilterDateRange([null, null]); // Clear the date range
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <div className="floating-btns-holder-artisan">
            {utils.hasPermission(
              primaryMenuRes,
              "Sales Reports",
              "sales_reports.download"
            ) && (
              <a
                href
                className={`${
                  quotationList?.result?.length == 0 ? "disabled" : ""
                } btn btn-primary btn-circle me-2`}
                variant="primary"
                onClick={handleDownload}
              >
                <DocumentDownload />
              </a>
            )}
          </div>
        </RB.Card.Header>

        <RB.CardHeader>
          <RB.Row>
            <RB.Col md={12} className={"border-bottom mb-2"}>
              <h6>Filters</h6>
            </RB.Col>

            {/* Sales by State */}
            <RB.Col md={4} className="mb-3">
              <RB.Form.Label>Sales by State</RB.Form.Label>
              <RB.Form.Select
                name="state"
                value={filters.state}
                className="form-control"
                onChange={handleFilterChange}
              >
                <option value="">Select State</option>
                {states.map((state) => (
                  <option key={state.state_name} value={state.state_code}>
                    {state.state_name}
                  </option>
                ))}
              </RB.Form.Select>
            </RB.Col>

            {/* Sales by District */}
            <RB.Col md={4} className="mb-3">
              <RB.Form.Label>District</RB.Form.Label>
              <RB.Form.Select
                name="district"
                value={filters.district}
                className="form-control"
                onChange={handleFilterChange}
              >
                <option value="">Select District</option>

                {districts?.map((district) => (
                  <option
                    key={district.district_code}
                    value={district.district_code}
                  >
                    {district.district_name}
                  </option>
                ))}
              </RB.Form.Select>
            </RB.Col>

            {/* Sales by City */}
            <RB.Col md={4} className="mb-3">
              <RB.Form.Label>City</RB.Form.Label>
              <Multiselect
                displayValue="key"
                name={"city"}
                onChange={handleFilterChange}
                onRemove={(selectedList) => {
                  setFilters({
                    ...filters,
                    city: "",
                  });
                }}
                onSelect={(selectedList) => {
                  const selectedId = selectedList.map((item) => item.cat);
                  setFilters({
                    ...filters,
                    city: selectedId.join(","),
                  });
                }}
                selectedValues={
                  filters.city
                    ? cities
                        .filter((name) => name.city_code === filters.city)
                        .map((name) => ({
                          cat: name.city_code,
                          key: name.city_name,
                        }))
                    : []
                }
                selectionLimit={1}
                options={cities.map((city) => ({
                  cat: city.city_code, // Use the ID for value
                  key: `${city.city_name}`, // Use the companyName for label
                }))} // Map over your nameList to create options
                style={{
                  searchBox: {
                    borderRadius: "30px",
                    borderColor: "#e4e6fc",
                    padding: "0.2rem 1.25rem",
                  },
                }}
              />
            </RB.Col>

            {/* Sales by Product */}
            <RB.Col md={4} className="mb-3">
              <RB.Form.Label>Product</RB.Form.Label>
              <Multiselect
                displayValue="key"
                name={"product"}
                onChange={handleFilterChange}
                onRemove={(selectedList) => {
                  setFilters({
                    ...filters,
                    product: "",
                  });
                }}
                onSelect={(selectedList) => {
                  const selectedId = selectedList.map((item) => item.cat);
                  setFilters({
                    ...filters,
                    product: selectedId.join(","),
                  });
                }}
                selectedValues={
                  filters.product
                    ? productOptions
                        .filter((product) => product.id === filters.product)
                        .map((product) => ({
                          cat: product.id,
                          key: product.product_name,
                        }))
                    : []
                }
                selectionLimit={1}
                options={productOptions.map((product) => ({
                  cat: product.id, // Use the ID for value
                  key: `${product.product_name}`, // Use the companyName for label
                }))} // Map over your nameList to create options
                style={{
                  searchBox: {
                    borderRadius: "30px",
                    borderColor: "#e4e6fc",
                    padding: "0.2rem 1.25rem",
                  },
                }}
              />
            </RB.Col>

            {/* Sales by SKU */}
            <RB.Col md={4} className="mb-3">
              <RB.Form.Label>SKU</RB.Form.Label>
              <Multiselect
                displayValue="key"
                name={"sku"}
                onChange={handleFilterChange}
                onRemove={(selectedList) => {
                  setFilters({
                    ...filters,
                    sku: "",
                  });
                }}
                onSelect={(selectedList) => {
                  const selectedId = selectedList.map((item) => item.cat);
                  setFilters({
                    ...filters,
                    sku: selectedId.join(","),
                  });
                }}
                selectedValues={
                  filters.sku
                    ? productOptions
                        .filter((sku) => sku.sku_no === filters.sku)
                        .map((sku) => ({
                          cat: sku.sku_no,
                          key: sku.sku_no,
                        }))
                    : []
                }
                selectionLimit={1}
                options={productOptions
                  .filter((sku) => sku.sku_no)
                  .map((sku) => ({
                    cat: sku.sku_no, // Use the ID for value
                    key: `${sku.sku_no}`, // Use the companyName for label
                  }))} // Map over your nameList to create options
                style={{
                  searchBox: {
                    borderRadius: "30px",
                    borderColor: "#e4e6fc",
                    padding: "0.2rem 1.25rem",
                  },
                }}
              />
            </RB.Col>

            {/* Sales by Executive, ASM, TSM, RSM */}
            <RB.Col md={4} className="mb-3">
              <RB.Form.Label>Sales by Executive/ASM/TSM/RSM</RB.Form.Label>
              <RB.Form.Select
                name="salesBy"
                value={filters.salesBy}
                className="form-control"
                onChange={handleFilterChange}
              >
                <option value="">Select Role</option>
                <option value="Sales Executive">Sales Executive</option>
                <option value="Area Sales Manager">Area Sales Manager</option>
                <option value="Territory Sales Manager">
                  Territory Sales Manager
                </option>
                <option value="Regional Sales Manager">
                  Regional Sales Manager
                </option>
              </RB.Form.Select>
            </RB.Col>

            {/* Sales by Zonal */}
            <RB.Col md={6} className="mb-3">
              <RB.Form.Label>Zone</RB.Form.Label>
              <RB.Form.Select
                name="zone"
                value={filters.zone}
                className="form-control"
                onChange={handleFilterChange}
              >
                <option value="">Select Zone</option>
                {zonalOptions.map((zonal, index) => (
                  <option key={index} value={zonal.id}>
                    {zonal.name}
                  </option>
                ))}
              </RB.Form.Select>
            </RB.Col>

            {/* Sales by Channel Partner & Channel Partner Name Input */}
            <RB.Col md={6} className="mb-3">
              <RB.Form.Label>Channel Partner</RB.Form.Label>
              <Multiselect
                displayValue="key"
                name={"cp"}
                onChange={handleFilterChange}
                onRemove={(selectedList) => {
                  setFilters({
                    ...filters,
                    cp: "",
                  });
                }}
                onSelect={(selectedList) => {
                  const selectedId = selectedList.map((item) => item.cat);
                  setFilters({
                    ...filters,
                    cp: selectedId.join(","),
                  });
                }}
                selectedValues={
                  filters.cp
                    ? cpOptions
                        .filter((name) => name.id === filters.cp)
                        .map((name) => ({
                          cat: name.id,
                          key: name.companyName,
                        }))
                    : []
                }
                selectionLimit={1}
                options={cpOptions.map((cpOption) => ({
                  cat: cpOption.id, // Use the ID for value
                  key: `${cpOption.companyName} (${cpOption.vendor_type})`, // Use the companyName for label
                }))} // Map over your nameList to create options
                style={{
                  searchBox: {
                    borderRadius: "30px",
                    borderColor: "#e4e6fc",
                    padding: "0.2rem 1.25rem",
                  },
                }}
              />
            </RB.Col>

            {/* <RB.Col md={6}>
              <RB.Form.Label>Channel Partner Name</RB.Form.Label>
              <RB.Form.Control
                type="text"
                name="channelPartnerName"
                value={filters.channelPartnerName}
                onChange={handleFilterChange}
              />
            </RB.Col> */}

            {/* Date Pickers - Only Show for Daily, Weekly, Fortnightly, Monthly */}

            <RB.Col md={3} className="mb-3">
              <RB.FormGroup className="mb-3">
                <RB.Form.Label>Date</RB.Form.Label>
                <DatePicker
                  selectsRange={true}
                  dateFormat="dd/MM/yyyy"
                  startDate={filterStartDate}
                  endDate={filterEndDate}
                  onChange={handleDateChange}
                  value={filterDateRange}
                  className="form-control form-control-auto"
                />
              </RB.FormGroup>
            </RB.Col>

            {/* Sales by Date Range */}
            <RB.Col md={3} className="mb-3">
              <RB.Form.Label>Sales by Date Range</RB.Form.Label>
              <RB.Form.Select
                name="dateRange"
                className="form-control"
                value={filters.dateRange}
                onChange={handleDateRangeChange}
              >
                <option value="">Select Date Range</option>
                {/* <option value="monthly">Monthly</option> */}
                <option value="quarterly">Quarterly</option>
                <option value="half yearly">Half Yearly</option>
                <option value="yearly">Yearly</option>
              </RB.Form.Select>
            </RB.Col>

            {/* Filter Buttons */}
            <RB.Col md={6} className={" d-flex align-items-center "}>
              <RB.FormGroup>
                <RB.Form.Label>&nbsp;</RB.Form.Label>
                <RB.Button
                  variant="primary"
                  type="button"
                  onClick={handleFilterSearchClick}
                >
                  Submit
                </RB.Button>
                <RB.Button
                  variant="light"
                  type="button"
                  className={"ms-1 me-3"}
                  onClick={handleFilterResetClick}
                >
                  Reset
                </RB.Button>

                {/* <RB.Button
                  className="btn btn-primary ms-2"
                  onClick={handleDownload}
                >
                  Download Excel
                </RB.Button> */}
              </RB.FormGroup>
            </RB.Col>
          </RB.Row>
        </RB.CardHeader>

        <RB.Card.Body style={{}}>
          {utils.hasPermission(
            primaryMenuRes,
            "Sales Reports",
            "sales_reports.view"
          ) && (
            <DataTable
              columns={columns}
              data={quotationList?.result}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={quotationList?.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              striped
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}

              // subHeader
              // subHeaderComponent={subHeaderComponent}
            />
          )}
          <div className=" justify-content-end fw-bold p-0 pe-3">
            Total Order Value: ₹{quotationList?.total_order_sum || "0.00"}
          </div>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
